import { ProductTypeName } from "@covertree/agent-portal-graphql";
import { formatProductTypeName } from "@utils/formatPolicyType";

export const mapProductTypeName = (
  type: ProductTypeName | null | undefined,
  isBookConversion: boolean
) => {
  const suffix = isBookConversion ? " (Book Conversion)" : "";

  return `${formatProductTypeName(type)}${suffix}`;
};
